import { Directory, Filesystem } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';
import { Case } from '../buildfire/rdb/cases';
import { formatCaseNumber } from '../../util/case';

const PDF_CONTENT_TYPE = 'application/pdf';

export const getReportFileName = (c: Case): string => {
  if (c.caseNumber == null) {
    throw new Error(`Case ${c.id} has no case number, cannot name its report`);
  }
  return `pocket-pathologist-${formatCaseNumber(c.caseNumber)}.pdf`;
};

/**
 * Downloads natively rather than via fetch: the WebView origin is not in the
 * signed URL's CORS allowlist, and this skips a base64 round-trip of the bytes.
 */
export const saveReportToDevice = async (
  signedUrl: string,
  fileName: string
): Promise<string> => {
  const { path } = await Filesystem.downloadFile({
    url: signedUrl,
    path: fileName,
    directory: Directory.Cache,
  });

  if (!path) {
    throw new Error(`Failed to save ${fileName} to the device`);
  }

  return path;
};

export const openSavedReport = (filePath: string): Promise<void> =>
  FileOpener.open({ filePath, contentType: PDF_CONTENT_TYPE });

// Anchor click, not window.open: generation outlives the browser's transient
// user activation, so a window would be blocked as a popup.
export const downloadReportInBrowser = (
  signedUrl: string,
  fileName: string
): void => {
  const link = window.document.createElement('a');
  link.href = signedUrl;
  link.download = fileName;
  link.rel = 'noopener';
  window.document.body.appendChild(link);
  link.click();
  window.document.body.removeChild(link);
};
